import { initializeNewRelicBrowser } from '../newrelic-browser-init';
import $ from 'jquery';

initializeNewRelicBrowser();

window.$ = $;
window.jQuery = $;

bootstrap = window.bootstrap = require('bootstrap');

import 'jquery-ui-bundle'
import Chart from 'chart.js'
import Highcharts from 'highcharts'
import HighchartsMore from 'highcharts/highcharts-more';
import 'jquery-touchswipe'
import moment from 'moment'
import 'daterangepicker'
import "@fortawesome/fontawesome-free/js/all";
import 'select2/dist/js/select2.js'
import 'controllers/companies'
import 'controllers/learner'
import Toastify from 'toastify-js'
import Sortable from 'sortablejs';
import "@hotwired/turbo-rails";
import 'chartkick/chart.js';

import Rails from '@rails/ujs';

require('bootstrap-select/js/bootstrap-select');
require("@rails/ujs").start()
require('../payment_methods');
require('packs/base.js');
require('jquery-ui/ui/widgets/autocomplete');
require("@nathanvda/cocoon")

window.Highcharts = Highcharts;
window.Rails = Rails;
window.Toastify = Toastify;
window.moment = moment;

HighchartsMore(Highcharts);
Turbo.session.drive = false

window.hideModalClasses = function() {
  $('.modal:visible').removeClass('fade').modal('hide').addClass('fade')
}

window.redirect_window = function(path) {
  Rails.ajax({
    url: path,
    type: 'get',
    dataType: 'script'
  });
}

$(document).on('turbo:load', function(event) {
  let searchParams = new URLSearchParams(window.location.search)
  $('[data-bs-toggle="tooltip"]').tooltip();

  $('.auto-submit').on("change", function() {
    this.form.submit();
  });

  $('.color-input').off("keyup");
  $('.color-input').on('input', function(event) {
    let color_code = $(event.target).val().trim();

    if(color_code == '') {
      return;
    } else if(color_code.charAt(0) != '#') {
      $(event.target).val(`#${color_code}`);
    }
  });

  window.addEventListener('load', (event) => {
    var url = new URL(window.location.href);
    var learner_id = url.searchParams.get('learner_id');

    if (learner_id ?? '') {
      Rails.ajax({
        url: `learners/${learner_id}/`,
        type: 'get',
        dataType: 'script'
      });
    }

  });
});

$('#copy-link').on('click', function(event) {
  var copyText = $('#copy-link-input');

  copyTextToClipboard(copyText.val());
  return false;
});

$(document).on('click', '.google-dmi-copy-btn', function(event) {
  event.preventDefault();
  const textToCopy = $(this).data('copy-text');
  if (textToCopy && typeof copyTextToClipboard === 'function') {
    copyTextToClipboard(textToCopy);
  }
})

// For a pie chart

function donutChart($container) {
$container.each(function() {
  const $this = $(this);
  const source = $this.data('source');
  const colors = $this.data('colors');
  const name = $this.data('name');

  var chart = Highcharts.chart('chart_container', {
    chart: {
      type: 'pie',
      plotShadow: false,
    },
    colors: ['#BEBEBE', '#EA4C8C', '#854DFF'],
    licenses: {
      enabled: false
    },
    title: {
      text: null,
    },
    tooltip: {
      pointFormat: '<b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        startAngle: 0,
        endAngle: 360,
        size: '100%',
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: false
        },
        showInLegend: true
      }
    },
    series: window.data
  });

  $this.addClass('chart-drawn');
});
}

document.addEventListener('DOMContentLoaded', function () {
  donutChart($('.donut'));
});


window.fallbackCopyTextToClipboard = function(text) {
  var textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.style.position="fixed";  //avoid scrolling to bottom
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    var successful = document.execCommand('copy');
    var msg = successful ? 'successful' : 'unsuccessful';
    console.log('Copying text command was ' + msg);
  } catch (err) {
    console.error('Oops, unable to copy', err);
  }

  document.body.removeChild(textArea);
}

window.copyTextToClipboard = function(text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(function() {
    $('#copy-paste-message').removeClass('d-none');

    console.log('Copying to clipboard was successful!');
  }, function(err) {
    console.error('Could not copy text: ', err);
  });
}

$('.hide-after-submit').each(function(){
  $(this).on('ajax:success', function(event) {
    $(this).addClass('d-none');
  });
})

window.bind_show_kiosk_filters = function() {
  $('.filter-radio').on('change', function(event) {
    $('.locations-drop-down').addClass('d-none');

    $('.form-select').attr('required', false);

    let filter_type = $(event.target).val();

    if (filter_type === 'location') {
      $('.locations-drop-down').removeClass('d-none');
      $('.location-select').attr('required', true);
    } else if (filter_type === 'all') {
      $(event.target).val(null);
    }
  })
}

window.removeQueryParams = function() {
  let url = new URL(window.location.href);
  url.search = new URLSearchParams();
  let newUrl = url.search ? url.href : url.href.replace('?', '');
  window.history.replaceState({}, document.title, newUrl);
}
